(() => {
  const observed = new WeakSet();
  function update(video, visible) {
    if (!visible) {
      video.pause();
      return;
    }
    const sources = video.querySelectorAll('source[data-src]');
    if (sources.length) {
      sources.forEach(source => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();
    }
    video.dispatchEvent(new CustomEvent('qa:video-ready', { bubbles: true }));
    if (video.dataset.qaAutoplay === 'true') {
      const playing = video.play();
      if (playing && playing.catch) playing.catch(() => {});
    }
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => update(entry.target, entry.isIntersecting));
      }, { rootMargin: '300px 0px' })
    : null;

  function init(root = document) {
    root.querySelectorAll('video[data-qa-deferred-video]').forEach(video => {
      if (observed.has(video)) return;
      observed.add(video);
      if (observer) observer.observe(video);
      else update(video, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  const mutations = new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches('video[data-qa-deferred-video]')) {
        init(node.parentNode);
      } else if (node.querySelector('video[data-qa-deferred-video]')) {
        init(node);
      }
    }));
  });
  mutations.observe(document.documentElement, { childList: true, subtree: true });
})();
